"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gallery = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
const _ = __importStar(require("lodash"));
class Gallery {
    constructor(element) {
        // elements
        this.element = null;
        this.images = [];
        this.images_count = 0;
        this.active_image = null;
        this.active_image_index = 0;
        this.skipper = null;
        this.fullscreen_image = null;
        this.scroll_X = 0;
        this.element = element;
        this.images = (0, cash_dom_1.default)('.gallery > .gallery-item', element);
        if (!this.images || this.images.length <= 1) {
            return;
        }
        this.images_count = this.images.length;
        this._addImageAction();
        // this._addGalleryIndicatorAction();
        this._initFullscreenImage();
    }
    _addImageAction() {
        this.images.each((index) => {
            let item = (0, cash_dom_1.default)(this.images[index]);
            item.on('click', (event) => {
                this.active_image = (0, cash_dom_1.default)(this.images[index]);
                this.active_image_index = index;
                this._updateFullscreenIndicator();
                this._changeFullscreenImage();
                this.fullscreen_image.show();
            });
        });
    }
    _getImageUrl(thumbnail_path, new_format = 'original') {
        //const thumbnail_path = $('img', thumbnail).attr('src');
        if (!thumbnail_path || thumbnail_path.length < 3) {
            return;
        }
        const regex = new RegExp('([^\\/]+)([\\.]\\w{3,4}$)', 'ms');
        const replace = `${new_format}\$2`; //1226x684
        const image_path = thumbnail_path.replace(regex, replace);
        return image_path;
    }
    /*public _addGalleryIndicatorAction() {
  
      const indicators = $('.gallery-indicator .indicator', this.element);
      indicators.each( (thumbnail_index :number) => {
  
        let indicator = $(indicators[thumbnail_index]);
        indicator.on('click', (event :any) => {
          this._onChangeBigImage(thumbnail_index);
        });
  
      });
    }*/
    /*public _updateGalleryIndicator() {
  
      const indicators = $('.gallery-indicator .indicator', this.element);
      if (!indicators || indicators.length <= 1) { return; }
  
      indicators.each( indicator_index => {
        if (indicator_index == this.active_image_index) {
          $(indicators[indicator_index]).addClass('active');
        } else {
          $(indicators[indicator_index]).removeClass('active');
        }
      });
  
    }*/
    _initFullscreenImage() {
        this.fullscreen_image = (0, cash_dom_1.default)('.fullscreen-image', this.element);
        if (!this.fullscreen_image) {
            return;
        }
        (0, cash_dom_1.default)('.prev', this.fullscreen_image).on('click touch', () => {
            let new_index = this.active_image_index - 1 < 0 ? this.images_count - 1 : this.active_image_index - 1;
            this.active_image = (0, cash_dom_1.default)(this.images[new_index]);
            this.active_image_index = new_index;
            this._updateFullscreenIndicator();
            this._changeFullscreenImage();
        });
        (0, cash_dom_1.default)('.next', this.fullscreen_image).on('click touch', () => {
            let new_index = this.active_image_index + 1 >= this.images_count ? 0 : this.active_image_index + 1;
            this.active_image = (0, cash_dom_1.default)(this.images[new_index]);
            this.active_image_index = new_index;
            this._updateFullscreenIndicator();
            this._changeFullscreenImage();
        });
        (0, cash_dom_1.default)('.close', this.fullscreen_image).on('click touch', () => {
            this.fullscreen_image.hide();
        });
        this.fullscreen_image.on('click touch', (e) => {
            const class_name = (0, cash_dom_1.default)(e.target).attr('class');
            if (_.indexOf(['backdrop', 'top', 'center', 'bottom'], class_name) >= 0) {
                this.fullscreen_image.hide();
            }
        });
        /*this.big_image.on('touchstart touchmove', (event :any) => {
          if (event.type == "touchstart") {
            this.scroll_X = (event.touches || event.originalEvent.touches)[0].clientX;
          } else if (event.type == "touchmove") {
            const scrollDiff = this.scroll_X - event.touches[0].clientX;
            if ( Math.abs(scrollDiff) < $(window).width() / 2) {
              return;
            }
    
            this.scroll_X = event.touches[0].clientX;
            if ( scrollDiff > 0 ) {
              let new_index = this.active_thumbnail_index + 1 >= this.images_count ? 0 : this.active_thumbnail_index + 1;
              this._onChangeBigImage( new_index );
              this._updateFullscreenIndicator();
              this._changeFullscreenImage();
            } else {
              let new_index = this.active_thumbnail_index - 1 < 0 ? this.images_count - 1 : this.active_thumbnail_index - 1;
              this._onChangeBigImage( new_index );
              this._updateFullscreenIndicator();
              this._changeFullscreenImage();
            }
          }
        });*/
        //this._addFullscreenIndicatorAction();
    }
    _changeFullscreenImage() {
        var _a;
        (0, cash_dom_1.default)('figure', this.fullscreen_image).show();
        (0, cash_dom_1.default)('figure img', this.fullscreen_image).addClass('loading');
        const image_src = this.active_image.attr('data-gallery-item-path');
        const image_title = this.active_image.attr('data-gallery-item-title');
        const image_credits = this.active_image.attr('data-gallery-item-credits');
        const fullscreen_src = (_a = this._getImageUrl(image_src, 'gallery-fullscreen')) !== null && _a !== void 0 ? _a : '';
        let img = new Image();
        img.src = fullscreen_src;
        img.onload = () => {
            (0, cash_dom_1.default)('figure img', this.fullscreen_image).attr('src', fullscreen_src);
            (0, cash_dom_1.default)('figure img', this.fullscreen_image).removeClass('loading');
            (0, cash_dom_1.default)('figure .title', this.fullscreen_image).html(image_title);
            (0, cash_dom_1.default)('figure .credits', this.fullscreen_image).html(image_credits);
        };
    }
    _updateFullscreenIndicator() {
        const indicators = (0, cash_dom_1.default)('.bottom .indicator', this.fullscreen_image);
        if (!indicators || indicators.length <= 1) {
            return;
        }
        indicators.each(indicator_index => {
            if (indicator_index == this.active_image_index) {
                (0, cash_dom_1.default)(indicators[indicator_index]).addClass('active');
            }
            else {
                (0, cash_dom_1.default)(indicators[indicator_index]).removeClass('active');
            }
        });
    }
}
exports.Gallery = Gallery;
